import "@/styles/index.css";

import cursor from "@/scripts/components/cursor";
import form from "@/scripts/components/form/form";
import mediaSlider from "@/scripts/components/media-slider";
import modal from "@/scripts/components/modal";
import pageHeader from "@/scripts/components/page-header";
import photoGallery from "@/scripts/components/photo-gallery";
import scrollbar from "@/scripts/components/scrollbar";
import scrollReveal from "@/scripts/components/scroll-reveal";
import scrollTo from "@/scripts/components/scroll-to";
import siteHeader from "@/scripts/components/site-header";
import slideToggle from "@/scripts/components/slide-toggle";

import Alpine from "alpinejs";
import focus from "@alpinejs/focus";
import { filterDropdown } from "@/scripts/alpine/filter-dropdown";
import { pillMarker } from "@/scripts/alpine/pill-marker";

cursor.init();
form.init();
mediaSlider.init();
modal.init();
pageHeader.init();
photoGallery.init();
scrollbar.init();
scrollReveal.init();
scrollTo.init();
siteHeader.init();
slideToggle.init();

Alpine.plugin(focus);
Alpine.data("filterDropdown", filterDropdown);
Alpine.data("pillMarker", pillMarker);
Alpine.start();

document.addEventListener("DOMContentLoaded", () => {
  setTimeout(() => {
    document.documentElement.classList.remove("_preload");
  }, 250);
});
